/** Plugin marketplace tab, registered into Web Settings > Plugins. */
import { fetchCatalog, installEntry, refreshCatalog, uninstallEntry } from "./api.js";
import { en, zh } from "./locales.js";
import { MarketTab } from "./MarketTab.js";
/** Dictionary namespace owned by this plugin. */
export const NS = 'settings.pluginHub';
/** Services required to contribute a Settings tab. */
export const inject = ['slots', 'locale'];
/**
 * Contribute the marketplace tab to the Plugins settings section.
 * @param ctx - the browser-side plugin context.
 */
export function apply(ctx) {
    ctx.effect(() => ctx.locale.register(NS, { zh, en }), 'plugin-hub: dictionaries');
    const t = ctx.locale.bind(NS);
    const injected = () => ({
        load: fetchCatalog,
        refresh: refreshCatalog,
        install: installEntry,
        uninstall: uninstallEntry,
        // A newly installed plugin's browser bundle only enters the boot manifest
        // on the next document request: the client HMR channel deliberately
        // ignores graph frames, so nothing would pick it up in place.
        reload: () => { window.location.reload(); },
    });
    // `settings.section`, not `settings.plugins.tab`: the Plugins section (and
    // the tab slot inside it) exists only in newer DSH builds, and registering
    // into a slot no host renders means the marketplace silently never appears.
    // `settings.section` is present in every build that ships Settings at all,
    // and gives the marketplace its own nav entry beside General and Models.
    ctx.slots.inject('settings.section', () => ctx.slots.register({
        name: 'settings.section',
        id: 'plugin-hub',
        // After General (0) and Models, so the built-in pages keep their order.
        order: 40,
        label: () => t('tab'),
        locale: NS,
        inject: injected,
    }, MarketTab));
}
